import logger from "./logger";

export const copyText = async (value) => {
  if (!value) return false;

  const text = String(value);

  if (navigator?.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (error) {
      logger.error(error);
    }
  }

  try {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "readonly");
    textarea.style.position = "fixed";
    textarea.style.top = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    const copied = document.execCommand("copy");
    document.body.removeChild(textarea);
    return copied;
  } catch (error) {
    logger.error(error);
    return false;
  }
};

export const copyTextWithStatus = async (value, label, showStatus) => {
  if (!value) return;

  const copied = await copyText(value);

  if (copied) {
    showStatus("info", `${label} скопирован`);
  } else {
    showStatus("error", "Не удалось скопировать");
  }
};

export const copyTableWithStatus = async (headers, rows, label, showStatus) => {
  if (!headers.length || !rows.length) return;

  const sanitize = (value) =>
    String(value ?? "")
      .replace(/<br\s*\/?>/gi, " ")
      .replace(/<\/?[^>]+>/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  const content = [headers, ...rows]
    .map((row) => row.map((cell) => sanitize(cell)).join("\t"))
    .join("\n");
  const copied = await copyText(content);

  if (copied) {
    showStatus("info", `${label} скопирована`);
  } else {
    showStatus("error", "Не удалось скопировать таблицу");
  }
};
